import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useNavigate } from '@tanstack/react-router';

import { useAppDispatch } from '@/context/store/hooks';
import { logout as logoutAction } from '@/context/store/slices/authSlice';
import { apiClient } from '@/lib/api-client';
import { clearForceChangeContext } from '@/lib/force-change-storage';
import { cancelSilentRefresh } from '@/lib/silent-refresh';
import { tokenStorage } from '@/lib/token-storage';

export function useLogoutMutation() {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async () => {
      const refreshToken = tokenStorage.getRefreshToken();
      if (refreshToken) {
        // Best-effort. Errors are tolerated; local state clears regardless.
        await apiClient
          .POST('/auth/logout', { body: { refreshToken } })
          .catch(() => undefined);
      }
    },
    onSettled: async () => {
      tokenStorage.clearAll();
      cancelSilentRefresh();
      clearForceChangeContext();
      dispatch(logoutAction());
      queryClient.clear();
      await navigate({ to: '/login' });
    },
  });
}
